import { on } from 'delegated-events'

const modal = document.getElementById('adk-speedbump')
const baseUrl = window.location.host

const fn = {
  init: () => {
    on('click', 'a', fn.handleOpen)
    on('click', '.speedbump-continue', fn.handleClose)
    on('click', '.speedbump-cancel', fn.handleClose)
  },

  handleOpen: (e) => {
    const anchor = e.target.closest('a')
    const allowedUrls = JSON.parse(modal.dataset.json).allowed_urls || []

    let shouldOpen = true

    allowedUrls.forEach((url) => {
      if (anchor.href.indexOf(url) !== -1) {
        shouldOpen = false
      }
    })

    if (anchor.classList.contains('ignore-speedbump')) {
      shouldOpen = false
    }

    if (anchor.dataset.modal && anchor.dataset.modal === 'video') {
      shouldOpen = false
    }

    if (anchor.dataset.tourVideo) {
      shouldOpen = false
    }

    if (anchor.dataset.scroll) {
      shouldOpen = false
    }

    if (anchor.href.indexOf('tel') !== -1) {
      shouldOpen = false
    }

    if (anchor.href.indexOf('mailto') !== -1) {
      shouldOpen = false
    }

    if (anchor.href.indexOf(baseUrl) !== -1) {
      shouldOpen = false
    }

    if (shouldOpen) {
      e.preventDefault()

      const continueBtn = modal.querySelector('.speedbump-continue')

      if (anchor.target) {
        continueBtn.target = anchor.target
      } else {
        continueBtn.target = null
      }

      continueBtn.href = anchor.href
      modal.classList.add('tingle-modal--visible')
    }
  },

  handleClose: () => {
    modal.classList.remove('tingle-modal--visible')
  },
}

export default {
  can: () => true,
  run: fn.init,
}
